module.exports = __webpack_public_path__ + "img/abstract.b0b3a2d4.svg";